export const MOBILE_WIDTH = 767;
export const TABLET_WIDTH = 1023;
export const SMALL_DESKTOP_WIDTH = 1366;
export const DESKTOP_WIDTH = 1440;
export const LARGE_DESKTOP_WIDTH = 1600;
export const SMALL_TV_WIDTH = 1920;
export const MEDIUM_TV_WIDTH = 2560;
export const LARGE_TV_WIDTH = 3840;
